import release from '../release-info.json';

export const APP_VERSION = release.version;
export const APP_RELEASE_NAME = release.name;
export const APP_BASE_VERSION = release.baseVersion;
export const APP_PRODUCT = release.product;
